import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@mui/material';

import ManageClientTags from '../../../../../ManageClientTags';
import { InfoTag } from '../../../../../../../components/Tags';
import {
  InfoContainer,
  StyledSubTitle,
  StyledTitle,
  StyledAccordion,
  StyledArrowIcon,
  SectionContent,
  ChipContainer,
  SectionActionWrapper,
} from '../../styles';
import { accordionId } from '../../utils';

import texts from './texts.json';

const { CLIENT_TAG_ACCORDION } = accordionId;

const ClientTagsSection = ({
  userId,
  customTags,
  handleExpand,
  expanded,
  isQAP,
}) => (
  <>
    <Divider flexItem />
    <StyledAccordion
      key={texts.clientTags}
      title={<StyledTitle>{texts.clientTags}</StyledTitle>}
      expanded={expanded === CLIENT_TAG_ACCORDION || !isQAP}
      onChange={handleExpand(CLIENT_TAG_ACCORDION)}
      expandIcon={isQAP && <StyledArrowIcon />}
      preventRotation={!isQAP}
      disableGutters
      actions={
        (expanded === CLIENT_TAG_ACCORDION || !isQAP) && (
          <SectionActionWrapper $isQAP={isQAP} onClick={(e) => e.stopPropagation()}>
            <ManageClientTags
              selectedClientList={[userId]}
              assignedTags={customTags}
              buttonLabel={texts.edit}
              editButton
            />
          </SectionActionWrapper>
        )
      }
    >
      <InfoContainer>
        <SectionContent>
          {customTags.length !== 0 ? (
            <ChipContainer>
              {customTags.map((tag) => (
                <InfoTag key={tag}>{tag}</InfoTag>
              ))}
            </ChipContainer>
          ) : (
            <StyledSubTitle>
              {texts.noTags}
            </StyledSubTitle>
          )}
        </SectionContent>
      </InfoContainer>
    </StyledAccordion>
  </>
);

ClientTagsSection.propTypes = {
  userId: PropTypes.string.isRequired,
  customTags: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleExpand: PropTypes.func.isRequired,
  expanded: PropTypes.string.isRequired,
  isQAP: PropTypes.bool.isRequired,
};

export default ClientTagsSection;
